import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentPlan } from "../apis/plans";
import { normalizePlanSummary } from "../utils/normalizePlan";
import { logout } from "./authSlice";

export const fetchCurrentPlan = createAsyncThunk(
    "plan/fetchCurrentPlan",
    async (_, { rejectWithValue }) => {
        try {
            const data = await getCurrentPlan();
            return data ?? null;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    loading: false,
    loaded: false,
    data: null,
    error: null,
};

const planSlice = createSlice({
    name: "plan",
    initialState,
    reducers: {
        clearPlan: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCurrentPlan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCurrentPlan.fulfilled, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.data = normalizePlanSummary(action.payload);
            })
            .addCase(fetchCurrentPlan.rejected, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.error = action.payload || "Something went wrong";
            })
            .addCase(logout, () => initialState);
    },
});

export const { clearPlan } = planSlice.actions;
export default planSlice.reducer;
